import React from "react"
import { concatStrings } from "../utilities"
import DfbIcon from "../ui-kit/dfb_icon"

const CTooltipIcon = ({ tooltip, icon, small, add_class }) => {
  const dataTooltip = tooltip ? { "data-tooltip": tooltip } : {}
  const baseClass = "c-TooltipIcon"
  const smallClass = small ? `${baseClass}--small` : ""

  return (
    <div
      {...dataTooltip}
      className={concatStrings(baseClass, smallClass, add_class)}
    >
      <DfbIcon icon_type={icon} add_class={`${baseClass}-icon`} />
    </div>
  )
}

export default CTooltipIcon
